<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="flex flex-wrap">
          <div
            class="w-full text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
          >
            ¿Olvidaste tu contraseña?
          </div>

          <div class="flex flex-col w-full pl-4">
            <form
              class="w-full max-w-lg"
              id="ResetPasswordForm"
              @submit.prevent
            >
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="name_category"
                    >Ingresa tu dirección de correo electrónico:</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="email"
                    type="email"
                    name="email"
                    v-model="email"
                  />
                  <p v-if="errors.email" class="text-red-500 text-xs italic">
                    Ingrese un correo valido
                  </p>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="SendResetPassword()"
                >
                  Enviar
                </button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Verifique su correo</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errors.codeError }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            ></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import AlertDialog from "./AlertDialog";

export default {
  name: "reset-password-modal",
  data() {
    return {
      email: null,
      errors: {
        email: false,
        valid_email: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.email = null;
      this.errors = {
        email: false,
        valid_email: false,
        codeError: "Ha ocurrido un error",
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    SendResetPassword() {
      console.log("SENDDATA");
      const form = document.getElementById("ResetPasswordForm");
      const signInData = new FormData(form);
      const validForm = this.checkFormResetPassword(signInData);

      if (validForm) {
        this.axios
          .post(
            "apidev/users/forgot_password",
            {
              email: this.email,
              type: "monitor",
            },
            this.config
          )
          .then((response) => {
            this.showingSuccess = true;
            this.reset();
            this.$emit("close");
          })
          .catch((error) => {
            console.error(error.response);
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.showingError = true;
          });
      }
    },

    checkFormResetPassword: function (signInData) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (signInData.get("email") === "") {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }

      if (!re.test(signInData.get("email"))) {
        this.errors.valid_email = this.errors.email ? false : true;
      } else {
        this.errors.valid_email = false;
      }

      if (this.errors.email || this.errors.valid_email) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
